import { getApi } from '../apiClient';
import { lessonPath } from '../lesson/api';
import {
  IDirectDocumentFetchApiResponse,
  IDirectDocumentsFetchApiResponse,
  IDirectDocumentUpdateApiResponse,
  ITaskDocumentCreateApiResponse,
  ITaskDocumentFetchApiResponse,
  tDocumentUpdateRequest,
  tDocumentRating,
  IDocumentRatingUpdateRequest,
  IDocumentsListRequestParams,
  INeedsActionsAssignmentsFetchApiResponse
} from './types';

// ASSIGNMENT TASK DOCUMENT APIs
export async function fetchTaskDocument(
  lessonId: number,
  taskId: number,
  preview = false
): Promise<ITaskDocumentFetchApiResponse> {
  const { data } = await getApi().get(
    `${lessonPath(lessonId, preview)}/tasks/${taskId}/document`
  );

  return data;
}

// ASSIGNMENT TASK DOCUMENT APIs
export async function fetchAssignmentTask(
  taskId: number
): Promise<ITaskDocumentFetchApiResponse> {
  const { data } = await getApi().get(`/student_assignments/${taskId}`);

  return data;
}

export async function submitAssignmentTask(
  id: number,
  data
): Promise<IDirectDocumentUpdateApiResponse> {
  const isFormData = data instanceof FormData;
  // /api/student_assignments/:student_assignment_id/document
  const { data: responseData } = await getApi().post(
    `/student_assignments/${id}/document`,
    isFormData ? data : { document: data },
    {
      headers: {
        'Content-Type': isFormData ? 'multipart/form-data' : 'application/json'
      }
    }
  );

  return responseData;
}

export async function updateAssignmentTask(
  id: number,
  document: tDocumentUpdateRequest
): Promise<IDirectDocumentUpdateApiResponse> {
  const isFormData = document instanceof FormData;
  const { data } = await getApi().put(
    `/student_assignments/${id}/document`,
    isFormData ? document : { document },
    {
      headers: {
        'Content-Type': isFormData ? 'multipart/form-data' : 'application/json'
      }
    }
  );

  return data;
}

export async function createDocument(
  lessonId: number,
  taskId: number,
  document: tDocumentUpdateRequest,
  preview = false
): Promise<ITaskDocumentCreateApiResponse> {
  const isFormData = document instanceof FormData;
  const { data } = await getApi().post(
    `${lessonPath(lessonId, preview)}/tasks/${taskId}/document`,
    isFormData ? document : { document },
    {
      headers: {
        'Content-Type': isFormData ? 'multipart/form-data' : 'application/json'
      }
    }
  );

  return data;
}

// DIRECT DOCUMENT APIs
export async function fetchDocuments(
  params?: IDocumentsListRequestParams
): Promise<IDirectDocumentsFetchApiResponse> {
  const { data } = await getApi().get(`/profile/documents`, {
    params: { 'q[title_eq]': params?.searchValue, ...params }
  });

  return data;
}

export async function fetchPendingAssignments(
  params?: IDocumentsListRequestParams
): Promise<INeedsActionsAssignmentsFetchApiResponse> {
  const { data } = await getApi().get(`/complex_assignments/require_action`, {
    params: { 'q[title_eq]': params?.searchValue, ...params }
  });

  return data;
}

export async function fetchWaitingForReviewAssignments(
  params?: IDocumentsListRequestParams
): Promise<INeedsActionsAssignmentsFetchApiResponse> {
  const { data } = await getApi().get(`/complex_assignments/waiting_for_review`, {
    params: { 'q[title_eq]': params?.searchValue, ...params }
  });

  return data;
}

export async function fetchCompletedAssignments(
  params?: IDocumentsListRequestParams
): Promise<INeedsActionsAssignmentsFetchApiResponse> {
  const { data } = await getApi().get(`/complex_assignments/completed`, {
    params: { 'q[title_eq]': params?.searchValue, ...params }
  });

  return data;
}

export async function fetchFailedAssignments(
  params?: IDocumentsListRequestParams
): Promise<INeedsActionsAssignmentsFetchApiResponse> {
  const { data } = await getApi().get(`/complex_assignments/failed`, {
    params: { 'q[title_eq]': params?.searchValue, ...params }
  });

  return data;
}

export async function fetchDocument(
  id: number
): Promise<IDirectDocumentFetchApiResponse> {
  const { data } = await getApi().get(`/profile/documents/${id}`);

  return data;
}

export async function updateDocument(
  documentId: number,
  document: tDocumentUpdateRequest
): Promise<IDirectDocumentUpdateApiResponse> {
  const isFormData = document instanceof FormData;
  const { data } = await getApi().put(
    `/profile/documents/${documentId}`,
    isFormData ? document : { document },
    {
      headers: {
        'Content-Type': isFormData ? 'multipart/form-data' : 'application/json'
      }
    }
  );

  return data;
}

export async function submitDocumentRating(
  documentId: number,
  rating: tDocumentRating
): Promise<IDirectDocumentUpdateApiResponse> {
  const body: IDocumentRatingUpdateRequest = {
    document: {
      rating
    }
  };
  const { data } = await getApi().put(`/profile/documents/${documentId}/rate`, body);

  return data;
}
